module.exports = __webpack_public_path__ + "img/DE01654.9b604f87.png";